export { createDomMotionComponent, motion } from './render/dom/motion.mjs';
export { m } from './render/dom/motion-minimal.mjs';
export { AnimatePresence } from './components/AnimatePresence/index.mjs';
export { AnimateSharedLayout } from './components/AnimateSharedLayout.mjs';
export { MotionConfig } from './components/MotionConfig/index.mjs';
export { LazyMotion } from './components/LazyMotion/index.mjs';
export { LayoutGroup } from './components/LayoutGroup/index.mjs';
export { Reorder } from './components/Reorder/index.mjs';
export { domAnimation } from './render/dom/features-animation.mjs';
export { domMax } from './render/dom/features-max.mjs';
export { useMotionValue } from './value/use-motion-value.mjs';
export { useMotionTemplate } from './value/use-motion-template.mjs';
export { MotionValue, motionValue } from './value/index.mjs';
export { resolveMotionValue } from './value/utils/resolve-motion-value.mjs';
export { useTransform } from './value/use-transform.mjs';
export { useSpring } from './value/use-spring.mjs';
export { useVelocity } from './value/use-velocity.mjs';
export { useScroll } from './value/use-scroll.mjs';
export { useElementScroll } from './value/scroll/use-element-scroll.mjs';
export { useViewportScroll } from './value/scroll/use-viewport-scroll.mjs';
export { useTime } from './value/use-time.mjs';
export { useWillChange } from './value/use-will-change/index.mjs';
export { useMotionValueEvent } from './utils/use-motion-value-event.mjs';
export { useReducedMotion } from './utils/reduced-motion/use-reduced-motion.mjs';
export { useReducedMotionConfig } from './utils/reduced-motion/use-reduced-motion-config.mjs';
export { animationControls } from './animation/hooks/animation-controls.mjs';
export { useAnimation, useAnimationControls } from './animation/hooks/use-animation.mjs';
export { useAnimationFrame } from './utils/use-animation-frame.mjs';
export { animate } from './animation/animate.mjs';
export { animateVisualElement } from './render/utils/animation.mjs';
export { useCycle } from './utils/use-cycle.mjs';
export { transform } from './utils/transform.mjs';
export { isValidMotionProp } from './motion/utils/valid-prop.mjs';
export { useIsPresent, usePresence } from './components/AnimatePresence/use-presence.mjs';
export { useInView } from './utils/use-in-view.mjs';
export { DragControls, useDragControls } from './gestures/drag/use-drag-controls.mjs';
export { useDomEvent } from './events/use-dom-event.mjs';
export { createMotionComponent } from './motion/index.mjs';
export { isMotionComponent } from './motion/utils/is-motion-component.mjs';
export { unwrapMotionComponent } from './motion/utils/unwrap-motion-component.mjs';
export { VisualElement } from './render/VisualElement.mjs';
export { addScaleCorrector } from './projection/styles/scale-correction.mjs';
export { useInstantTransition } from './utils/use-instant-transition.mjs';
export { useInstantLayoutTransition } from './projection/use-instant-layout-transition.mjs';
export { useResetProjection } from './projection/use-reset-projection.mjs';
export { buildTransform } from './render/html/utils/build-transform.mjs';
export { clamp } from './utils/clamp.mjs';
export { delay } from './utils/delay.mjs';
export { distance, distance2D } from './utils/distance.mjs';
export { mix } from './utils/mix.mjs';
export { pipe } from './utils/pipe.mjs';
export { wrap } from './utils/wrap.mjs';
export { sync } from './frameloop/index.mjs';
export { frameData } from './frameloop/data.mjs';
export { startOptimizedAppearAnimation } from './animation/optimized-appear/start.mjs';
export { optimizedAppearDataAttribute } from './animation/optimized-appear/data-id.mjs';
export { spring } from './animation/legacy-popmotion/spring.mjs';
export { MotionContext, useVisualElementContext } from './context/MotionContext/index.mjs';
export { MotionConfigContext } from './context/MotionConfigContext.mjs';
export { PresenceContext } from './context/PresenceContext.mjs';
export { LayoutGroupContext } from './context/LayoutGroupContext.mjs';
export { DeprecatedLayoutGroupContext } from './context/DeprecatedLayoutGroupContext.mjs';
export { SwitchLayoutGroupContext } from './context/SwitchLayoutGroupContext.mjs';
export { anticipate } from './easing/anticipate.mjs';
export { backIn, backInOut, backOut } from './easing/back.mjs';
export { circIn, circInOut, circOut } from './easing/circ.mjs';
export { easeIn, easeInOut, easeOut } from './easing/ease.mjs';
export { cubicBezier } from './easing/cubic-bezier.mjs';
export { FlatTree } from './render/utils/flat-tree.mjs';
export { useAnimatedState as useDeprecatedAnimatedState } from './animation/hooks/use-animated-state.mjs';
export { useInvertedScale as useDeprecatedInvertedScale } from './value/use-inverted-scale.mjs';
export { AnimationType } from './render/utils/types.mjs';
export { animations } from './motion/features/animations.mjs';
export { checkTargetForNewValues } from './render/utils/setters.mjs';
export { createBox } from './projection/geometry/models.mjs';
export { calcLength } from './projection/geometry/delta-calc.mjs';
export { filterProps } from './render/dom/utils/filter-props.mjs';
export { makeUseVisualState } from './motion/utils/use-visual-state.mjs';
export { isDragActive } from './gestures/drag/utils/lock.mjs';
export { addPointerEvent } from './events/use-pointer-event.mjs';
export { addPointerInfo } from './events/event-info.mjs';
export { isMotionValue } from './value/utils/is-motion-value.mjs';
export { isBrowser } from './utils/is-browser.mjs';
export { useUnmountEffect } from './utils/use-unmount-effect.mjs';
export { useIsomorphicLayoutEffect } from './utils/use-isomorphic-effect.mjs';
export { useForceUpdate } from './utils/use-force-update.mjs';
